import { render, staticRenderFns } from "./ArticleDialogVideo.vue?vue&type=template&id=70caf680&scoped=true&"
import script from "./ArticleDialogVideo.vue?vue&type=script&lang=js&"
export * from "./ArticleDialogVideo.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDialogVideo.vue?vue&type=style&index=0&id=70caf680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70caf680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDialog,VIcon})
